// extracted by mini-css-extract-plugin
export default {"clickable":"SupportUserConversationsPageDetailsMenu_clickable__mlLx5","virtuoso":"SupportUserConversationsPageDetailsMenu_virtuoso__mpikm"};